<pcs-multi-select
  [disabled]="showOnlyRowsWithNoOptions"
  [selected]="selectedOptions"
  [options]="options$ | async"
  [displayProperty]="props.displayProperty"
  (selectionChanged)="onOptionSelected($event)">
</pcs-multi-select>

<pcs-checkbox
  *ngIf="props.showRowsWithNoOptions"
  inputId="showRowsWithNoOptions"
  [label]="props.showRowsWithNoOptionsLabel"
  [checked]="showOnlyRowsWithNoOptions"
  [disabled]="addressedToMyIm"
  (selectionChanged)="onShowOnlyRowsWithNoOptionsChanged($event)">
</pcs-checkbox>

<pcs-checkbox *ngIf="isImUser()"
              inputId="addressedToMyIM"
              label="label.addressed.to.my.im"
              [checked]="addressedToMyIm"
              [disabled]="showOnlyRowsWithNoOptions"
              (selectionChanged)="onAddressedToMyIMOptionChanged($event)">
</pcs-checkbox>
